import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { LayoutDashboard, Menu, Calendar, Phone, LogOut } from "lucide-react";
import { supabase } from "@/lib/supabase";

interface AdminLayoutProps {
  children: React.ReactNode;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const navItems = [
    { path: "/admin", label: "Dashboard", icon: <LayoutDashboard size={20} /> },
    { path: "/admin/menu", label: "Menu Management", icon: <Menu size={20} /> },
    { path: "/admin/events", label: "Events", icon: <Calendar size={20} /> },
    { path: "/admin/contact", label: "Contact Info", icon: <Phone size={20} /> },
  ];

  const handleSignOut = async () => {
    await supabase.auth.signOut();
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen bg-lounge-dark text-lounge-light flex">
      {/* Sidebar */}
      <aside className="w-64 bg-lounge-charcoal border-r border-lounge-gold/20 p-4 flex flex-col">
        <div className="mb-8">
          <h1 className="text-2xl font-display font-bold text-lounge-gold">Seven8Nine</h1>
          <p className="text-sm text-lounge-light/60">Admin Portal</p>
        </div>

        <nav className="flex-1">
          <ul className="space-y-2">
            {navItems.map((item) => (
              <li key={item.path}>
                <Link
                  to={item.path}
                  className={`flex items-center gap-3 px-4 py-2 rounded-lg transition-colors ${
                    location.pathname === item.path
                      ? "bg-lounge-gold/20 text-lounge-gold"
                      : "text-lounge-light/70 hover:bg-lounge-gold/10 hover:text-lounge-gold"
                  }`}
                >
                  {item.icon}
                  <span>{item.label}</span>
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <button
          onClick={handleSignOut}
          className="flex items-center gap-3 px-4 py-2 text-lounge-light/70 hover:text-lounge-gold transition-colors mt-auto"
        >
          <LogOut size={20} />
          <span>Sign Out</span>
        </button>
      </aside>

      {/* Main Content */}
      <main className="flex-1 p-8">
        {children}
      </main>
    </div>
  );
};

export default AdminLayout; 